import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_coupon_attachment_RowClass, bl_fi_mst_coupon_hdr_RowClass} from '../../../dbschema';
import {bl_fi_mst_coupon_line_RowClass} from '../../../dbschema';

export class VoucherV2WithAttachmentContainerModel extends BaseContainerModel {
  bl_fi_mst_coupon_hdr: bl_fi_mst_coupon_hdr_RowClass = new bl_fi_mst_coupon_hdr_RowClass();
  bl_fi_mst_coupon_lines: bl_fi_mst_coupon_line_RowClass[] = [];
  bl_fi_mst_coupon_attachments: bl_fi_mst_coupon_attachment_RowClass[] = [];
}
